export default {
  mapStyle: 'mapbox://styles/mzdk/ck8efgnkn03ou1inmdaiekw83',
  mapboxApiAccessToken: process.env.REACT_APP_MAPBOX_KEY,
}
